

































import { ConsultoresService } from "@/services/consultores.service";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Modal,
  },
})
export default class CancelarTransacao extends Vue {
  transacao: any | null = null;
  motivo: string | null = null;
  valid = false;
  loading = false;

  rules = {
    motivo: [required()],
  };

  get tituloManter(): string {
    return `Cancelar transação ${this.transacao && this.transacao.tipoMeioPagamento}`;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async cancelamentoTransacao(transacao: any) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.transacao = transacao;

    return p;
  }

  async cancelarTransacao() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    this.loading = true;
    if (form.validate()) {
      try {
        if (this.transacao.tipoMeioPagamento == 'CIELO') {
          await ConsultoresService.CancelarCielo(this.transacao.idTransacao!, this.motivo!);
          return;
        }

        await ConsultoresService.CancelarInter(this.transacao.idTransacao!, this.motivo!);

        return;
      } catch {
        console.error("Erro ao cancelar transação CIELO");
      } finally {
        this.loading = false;
        modal.close(false);
      }
    }

    this.loading = false;
    modal.close(false);
  }
}
